import { create } from "zustand";

interface WelcomeRewardModalState {
  showWelcomeRewardModal: boolean;
  setShowWelcomeRewardModal: (show: boolean) => void;
}

export const useWelcomeRewardModalStore = create<WelcomeRewardModalState>((set) => ({
  showWelcomeRewardModal: false,
  setShowWelcomeRewardModal: (showWelcomeRewardModal) => set({ showWelcomeRewardModal }),
}));

interface ClaimRewardModalState {
  showClaimRewardModal: boolean;
  setShowClaimRewardModal: (show: boolean) => void;
}

export const useClaimRewardModalStore = create<ClaimRewardModalState>((set) => ({
  showClaimRewardModal: false,
  setShowClaimRewardModal: (showClaimRewardModal) => set({ showClaimRewardModal }),
}));
